var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-3 custom-callout",
      attrs: { "border-color": _vm.color, "has-toggle": false }
    },
    [
      _c("div", { staticClass: "row align-items-center mx-0 px-2 py-2" }, [
        _c(
          "div",
          {
            staticClass:
              "col-md-2 col-sm-12 icon-container border-right border-right--variant d-flex d-md-block d-sm-flex"
          },
          [
            _c("custom-balloon", {
              staticClass: "mt-2 p-2 font-weight-normal font-16 flex-grow-1",
              attrs: {
                "background-color": _vm.color,
                text: _vm.billingStatusName
              }
            }),
            _c(
              "div",
              {
                staticClass:
                  "font-weight-bold color-black text-center mt-3 flex-grow-1"
              },
              [_vm._v(" " + _vm._s(_vm.billNumber) + " ")]
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-12 d-none d-md-none d-sm-block" }, [
          _c("hr")
        ]),
        _c("div", { staticClass: "col-md-7" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-3 col-sm-12" }, [
              _c("div", { staticClass: "gray-6 font-14" }, [
                _vm._v(" Periodo: ")
              ]),
              _c("div", { staticClass: "font-weight-normal color-black" }, [
                _vm._v(" " + _vm._s(_vm.period) + " ")
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-md-3 col-sm-12 mt-3 mt-md-0 mt-sm-3" },
              [
                _c("div", { staticClass: "gray-6 font-14" }, [
                  _vm._v(" Centro: ")
                ]),
                _c("div", { staticClass: "font-weight-normal color-black" }, [
                  _vm._v(" " + _vm._s(_vm.centerName) + " ")
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "col-md-3 col-sm-12 mt-3 mt-md-0 mt-sm-3" },
              [
                _c("div", { staticClass: "gray-6 font-14" }, [
                  _vm._v(" Monto: ")
                ]),
                _c("div", { staticClass: "font-weight-normal color-black" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("price")(_vm.totalBillAmount)) + " "
                  )
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "col-md-3 col-sm-12 mt-3 mt-md-0 mt-sm-3" },
              [
                _c("div", { staticClass: "gray-6 font-14" }, [
                  _vm._v(" Fecha Estatus: ")
                ]),
                _c("div", { staticClass: "font-weight-normal color-black" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$formatDate(
                          _vm.billingStatusDate,
                          _vm.$templateDate.default
                        )
                      ) +
                      " "
                  )
                ])
              ]
            ),
            _c("div", { staticClass: "col-md-6 col-sm-12 mt-3" }, [
              _c("div", { staticClass: "gray-6 font-14" }, [
                _vm._v(" Proveedor: ")
              ]),
              _c("div", { staticClass: "font-weight-normal color-black" }, [
                _vm._v(" " + _vm._s(_vm.companyName) + " ")
              ])
            ]),
            _c("div", { staticClass: "col-md-3 col-sm-12 mt-3" }, [
              _c("div", { staticClass: "gray-6 font-14" }, [
                _vm._v(" Servicios a ofrecer: ")
              ]),
              _c("div", { staticClass: "font-weight-normal color-black" }, [
                _vm._v(" " + _vm._s(_vm.offeredService) + " ")
              ])
            ]),
            _vm.isDirectPayment
              ? _c("div", { staticClass: "col-md-3 col-sm-12 mt-3" }, [
                  _c("div", { staticClass: "gray-6 font-14 mb-1" }, [
                    _vm._v(" Facturación: ")
                  ]),
                  _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-pill badge p-2 px-2 mr-3 text-nowrap flex-shrink-0",
                      class: `border-color--green`,
                      staticStyle: { "background-color": "#e3ffe9" }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "font-weight-bold ml-1",
                          class: `color-green`
                        },
                        [_vm._v(" Pago Directo ")]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "col-md-6 col-sm-12 mt-3" }, [
              _c("div", { staticClass: "gray-6 font-14" }, [
                _vm._v(" Intervenido por: ")
              ]),
              _c("div", { staticClass: "font-weight-normal color-black" }, [
                _vm._v(" " + _vm._s(_vm.interventorUsers) + " ")
              ])
            ])
          ])
        ]),
        _c(
          "div",
          {
            staticClass:
              "col-md-3 col-sm-12 col-spacing d-flex align-items-center justify-content-end flex-nowrap mt-3 mt-md-0 mt-sm-3"
          },
          [
            !_vm.canCancel
              ? _c("action-button", {
                  staticClass: "px-4 flex-shrink-0 transparent-color",
                  attrs: {
                    i: "fas fa-file-import",
                    text: "Entrar",
                    variant: "outline-success"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("enter", _vm.id)
                    }
                  }
                })
              : _c("drop-down", {
                  staticClass: "actions-dropdown",
                  attrs: { items: _vm.actionItems }
                })
          ],
          1
        )
      ]),
      _vm.showCancel
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-9 col-sm-12" },
              [
                _c("div", { staticClass: "gray-6 font-14 mb-2" }, [
                  _vm._v(" Comentario: ")
                ]),
                _c(
                  "validation-observer",
                  {
                    ref: `submitUpdateBillingStatusRef-${_vm.id}`,
                    attrs: { novalidate: "", tag: "form" }
                  },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      "Favor de entrar un comentario.",
                                    error: errors[0]
                                  },
                                  model: {
                                    value: _vm.cancelReason,
                                    callback: function($$v) {
                                      _vm.cancelReason = $$v
                                    },
                                    expression: "cancelReason"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3480384260
                      )
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-3 text-right mt-4" },
              [
                _c(
                  "action-button",
                  {
                    staticClass: "w-45",
                    attrs: {
                      i: "fas fa-times-circle",
                      variant: "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                    },
                    on: {
                      click: function($event) {
                        _vm.showCancel = false
                      }
                    }
                  },
                  [_vm._v(" Cancelar ")]
                ),
                _c(
                  "action-button",
                  {
                    attrs: {
                      i: "fas fa-arrow-circle-right",
                      variant: "success pl-4 pr-4"
                    },
                    on: {
                      click: function($event) {
                        return _vm.cancelEvent()
                      }
                    }
                  },
                  [_vm._v(" Cambiar ")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }